import { createSlice } from "@reduxjs/toolkit";
import { TOKEN, USER } from "constants/context";

const initialState = {
    token: localStorage.getItem(TOKEN) ? localStorage.getItem(TOKEN) : "",
    user: localStorage.getItem(USER) ? localStorage.getItem(USER) : "",
    buttonsState: localStorage.getItem("display") ? JSON.parse(localStorage.getItem("display")) : { buttons: true, calendar: false },
    notificationMessages: null
};

export const appStateSlice = createSlice({
    name: "appState",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        logout: (state) => {
            localStorage.removeItem(TOKEN);
            state.token = "";
            localStorage.removeItem(USER);
            state.user = "";
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setButtonsState: (state, action) => {
            localStorage.setItem("display", JSON.stringify(action.payload));
            state.buttonsState = action.payload;
        },
        addNotificationMessages: (state, action) => {
            state.notificationMessages = action.payload;
        },
        removeNotificationMessages: (state) => {
            state.notificationMessages = null;
        },
    }
});

export const {
    setToken,
    setUser,
    logout,
    setButtonsState,
    addNotificationMessages,
    removeNotificationMessages
} = appStateSlice.actions;

export default appStateSlice.reducer;